import api from "services/api";

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    forestageCityInfoUpdateDate: build.query<string, void>({
      query: () => ({
        url: "/city-info-update-date",
      }),
      transformResponse: (res: { id: number; cityDataUpdateDt: string }) =>
        new Intl.DateTimeFormat("zh-TW", { dateStyle: "long" }).format(
          new Date(res.cityDataUpdateDt)
        ),
    }),
  }),
  overrideExisting: false,
});

export const { useForestageCityInfoUpdateDateQuery } = extendedApi;
